import { MenuHierarchy, SidebarItem } from './Sidebar.types';

export const getMenuHierarchy = (items: SidebarItem[]) => {
  const hierarchy: MenuHierarchy = {};

  const setSubMenuHierarchy = (item: SidebarItem, parentIds: string[]) => {
    const menuId = item.id || item.to;
    if (!menuId) return;
    const subMenuHierarchy = [...parentIds, menuId];
    hierarchy[menuId] = subMenuHierarchy;

    if (!item.items?.length) return;
    item.items.forEach((subItem) => setSubMenuHierarchy(subItem, subMenuHierarchy));
  };

  items.forEach((item) => setSubMenuHierarchy(item, []));
  return hierarchy;
};
